export default function RightArrow(){
    return(<svg width="18" height="15" viewBox="0 0 18 15" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 7.5H17M17 7.5L11 1.5M17 7.5L11 13.5"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
   )
}